import { render, staticRenderFns } from "./familyAddCust.vue?vue&type=template&id=07ae5cdf&scoped=true"
import script from "./familyAddCust.vue?vue&type=script&lang=js"
export * from "./familyAddCust.vue?vue&type=script&lang=js"
import style0 from "./familyAddCust.vue?vue&type=style&index=0&id=07ae5cdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ae5cdf",
  null
  
)

export default component.exports